export default __webpack_public_path__ + "static/media/micky.61e893e2.jpeg";